import React from "react";

import { Checkbox } from "@portex-pro/ui-components";
import { ContactType } from "api/rest/partners/types/domain";
import TableView, { TableViewColumns, TableViewRows } from "components/TableView";
import Text from "components/Text";
import compact from "lodash/compact";
import { useTranslation } from "react-i18next";
import { getUserFullName } from "utils/user";

// import PartnerTagView from "./PartnerTagView";

interface PartnersTableViewProps {
  partners: ContactType[];
  isLoading: boolean;
  isChecked: (contact: ContactType) => boolean;
  onClickRow: (contact: ContactType) => void;
  onClickSelectAll: (event: React.ChangeEvent<HTMLInputElement>, checked: boolean) => void;
  checkboxIndeterminate?: boolean;
}

const PartnersTableView: React.FC<PartnersTableViewProps> = (props) => {
  const { partners, isLoading, isChecked, onClickRow, onClickSelectAll, checkboxIndeterminate } = props;
  const { t } = useTranslation("shipper");

  const tableRows: TableViewRows<ContactType> = {
    startingIcon: (contract) => {
      return <Checkbox checked={isChecked(contract)} />;
    },
    headerStartingIcon: (
      <Checkbox
        onChange={onClickSelectAll}
        indeterminate={checkboxIndeterminate}
        // it should work without this, but for some reason it inherits its color as blue if you check all and then uncheck one,
        // but not if you check one
        style={{ color: checkboxIndeterminate ? "grey" : undefined }}
      />
    ),
    startingIconHeaderCellProps: {
      width: "42px",
      style: {
        padding: 0,
        textAlign: "right",
      },
    },
    startingIconCellProps: {
      style: {
        textAlign: "right",
        padding: 0,
      },
    },
    onClickRow,
  };

  const tableColumns: TableViewColumns<ContactType> = [
    {
      name: t("company"),
      renderCell: (partner) => <Text size="small">{partner.company_name}</Text>,
    },
    {
      name: t("contact"),
      renderCell: (partner) => <Text size="small">{getUserFullName({ user: partner })}</Text>,
    },
    {
      name: t("email"),
      renderCell: (partner) => (
        <Text size="small" typographyProps={{ style: { overflowWrap: "anywhere" } }}>
          {partner.user.email}
        </Text>
      ),
    },
    {
      name: t("location"),
      renderCell: (partner) => <Text size="small">{compact([partner.city, partner.state]).join(", ")}</Text>,
      headerCellProps: {
        style: {
          textAlign: "right",
        },
      },
      cellProps: {
        style: {
          textAlign: "right",
        },
      },
    },
    /** @todo tags are currently not implemented on rest */
    // {
    //   name: t("tags"),
    //   renderCell: PartnerTagView,
    // },
  ];

  return <TableView isLoading={isLoading} items={partners} columns={tableColumns} rows={tableRows} />;
};

export default PartnersTableView;
